import Axios from 'axios'
import { API_URL_JD_EXAMPLES_LIST } from 'src/@legacy/@core/utilities/APIConstant'
import withAppProvider from 'src/@legacy/layout/hoc/withAppProvider'
import withHeaderDynamic from 'src/@legacy/layout/hoc/withHeaderDynamic'
import JDExamplesPage from 'src/@legacy/wrapper/jd-examples'
import { JDType } from 'src/@legacy/wrapper/jd-examples/components/JDWrapper'

export const fetchJDExamplesList = (queryString?: string): Promise<JDType[]> =>
  Axios.get(`${API_URL_JD_EXAMPLES_LIST}${queryString ? `?${queryString}` : ''}`, {}).then((rs) => rs.data.data)

export async function getServerSideProps() {
  const data = await fetchJDExamplesList()
  // Pass data to the page via props
  return { props: { JDData: data } }
}

export default withAppProvider(withHeaderDynamic(JDExamplesPage), { loadOnClient: false })
